export const minTableColumnWidth = "20ch";